import { NewOrderAttributes, TNewOrderAttributes } from "@/entities/new-order";

type TDaysAttributeList = {
  title: string;
  value: TNewOrderAttributes;
};

export const DAYS_ATTRIBUTES: TDaysAttributeList[] = [
  {
    title: "1-st",
    value: NewOrderAttributes.La1day,
  },
  {
    title: "2-nd",
    value: NewOrderAttributes.La2day,
  },
  {
    title: "3-rd",
    value: NewOrderAttributes.La3day,
  },
  {
    title: "4-th",
    value: NewOrderAttributes.La4day,
  },
  {
    title: "5-th",
    value: NewOrderAttributes.La5day,
  },
  {
    title: "6-th",
    value: NewOrderAttributes.La6day,
  },
  {
    title: "7-th",
    value: NewOrderAttributes.La7day,
  },
  {
    title: "8-th",
    value: NewOrderAttributes.La8day,
  },
  {
    title: "9-th",
    value: NewOrderAttributes.La9day,
  },
  {
    title: "10-th",
    value: NewOrderAttributes.La10day,
  },
  {
    title: "11-th",
    value: NewOrderAttributes.La11day,
  },
  {
    title: "12-th",
    value: NewOrderAttributes.La12day,
  },
  {
    title: "13-th",
    value: NewOrderAttributes.La13day,
  },
  {
    title: "14-th",
    value: NewOrderAttributes.La14day,
  },
];
